<template>
  <div>
    <base-profile />
    <div class="container-profile pb-5">
      <profile-mis-direcciones />
    </div>
  </div>
</template>
<script>
import BaseProfile from '@/components/profile/BaseProfile'
import ProfileMisDirecciones from '@/components/profile/ProfileMisDirecciones'
export default {
  components: { BaseProfile, ProfileMisDirecciones },
  // mounted() {
  //     document.title = 'Perfil | DEREK Tienda Online'
  //     this.$gtag.pageview(this.$route.fullPath);
  // },
}
</script>
